<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default  {
  name:  'App',
  created(){
    // sessionStorage.setItem('hostName',document.location.hostname)
  }
}
</script>

<style lang="scss">
#app{
  width: 100%;
  height: 100%;
}
* {
  box-sizing: border-box
}
body {
  min-width: 1200px;
}
@import './common/scss/common.scss';
@import './common/scss/alibaba_iconfont_config.scss';  
@import './common/theme/index.scss';
</style>




// WEBPACK FOOTER //
// src/App.vue